import React from 'react'
import { LabeledStatus } from 'domains/scope-and-sequence/components'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { parsedSheetDataAtom } from 'domains/scope-and-sequence/features/parser/atoms'
import { commonCoreFrameworkAtom, selectedFrameworkAtom } from './atoms'
import { lessonMappingTreesAtom } from 'domains/scope-and-sequence/features/lesson-mappings/atoms'
import { pluralizeCount } from 'shared/utils'
import { useCreateTreeStructure } from './hooks'

export function ScopeSequenceValidation() {
  const data = useAtomValue(parsedSheetDataAtom)
  const completeText = data?.map(({ grade }) => grade).join(', ')
  return (
    <LabeledStatus
      label="Pacing Guide Template"
      isComplete={!!data?.length}
      completeText={`Grades: ${completeText}`}
    />
  )
}

export function CrosswalkValidation() {
  const selectedFramework = useAtomValue(selectedFrameworkAtom)
  const ccFramework = useAtomValue(commonCoreFrameworkAtom)
  const incompleteText = selectedFramework
    ? 'Common Core Subject Missing'
    : 'Select a Framework'
  return (
    <LabeledStatus
      label="Select Crosswalk"
      isComplete={!!selectedFramework && !!ccFramework}
      completeText={selectedFramework?.name}
      incompleteText={incompleteText}
    />
  )
}

export function LessonPoolValidation() {
  const trees = useAtomValue(lessonMappingTreesAtom)
  const completeText = `${pluralizeCount('tree', trees?.length)} selected`
  return (
    <LabeledStatus
      label="Add Source Trees"
      isComplete={!!trees?.length}
      completeText={completeText}
    />
  )
}

export function TreeStructureValidation() {
  const { canCreate } = useCreateTreeStructure()
  return (
    <LabeledStatus
      label="Create Scope and Sequence"
      isComplete={canCreate}
      completeText="Can Create Scope and Sequence"
    />
  )
}
